export default function Button({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "default",
  className = "",
  active = false,
}) {
  const base =
    "inline-flex items-center justify-center rounded-md font-medium transition-all px-3 py-2 sm:px-5 sm:py-2 text-xs sm:text-sm shadow hover:shadow-md";

  const variants = {
    default: "bg-black text-white hover:bg-gray-800",
    danger: "bg-red-500 hover:bg-red-600 text-white",
    success: "bg-green-500 hover:bg-green-600 text-white",
  };

  const activeClass = active
    ? "bg-[#93c5fd] text-white"
    : "bg-black text-white hover:bg-gray-800";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${variant === "default" ? activeClass : variants[variant]
        } ${className} cursor-pointer`}
    >
      {children}
    </button>
  );
}